module.exports = __webpack_public_path__ + "static/media/NoPoster.b6c0d625.svg";